import { render } from "./psiCategory.vue?vue&type=template&id=130413f9"
import script from "./psiCategory.vue?vue&type=script&lang=jsx"
export * from "./psiCategory.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__